<mat-card class="pageWrapper">
    <mat-card-content>
        <div class="mat-elevation-z8 section-wrap">
            <div class="page-title-wrap">
                <h2 class="page-title">
                    ICAF Dashboard
                </h2>
            </div>
            <div class="form-wrap">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Select</mat-label>
                    <!-- (selectionChange)="getTopicId()" [(ngModel)]="addAssessmentReqObj.testId"
                        name="testId" [disabled]="addAssessmentReqObj.newTestId.length != 0" -->
                    <mat-select (selectionChange)="getReportData()" [(ngModel)]="selectedId" name="selectedId">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let successFactor of successFactorList"
                            [value]="successFactor.id">{{successFactor.identifiersubject}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mat-elevation-z8" *ngIf="initialLoad">
                <div class="search-create-cont">
                    <mat-form-field appearance="outline">
                        <mat-label>Search </mat-label>
                        <input matInput (keyup)="applyFilter($event)" #input>
                    </mat-form-field>
                </div>
                <mat-accordion>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Advanced Filters
                            </mat-panel-title>
                            <mat-panel-description>
                                Click To Expand
                                <mat-icon>tune</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="container">
                            <div class="row row row-cols-1 row-cols-md-4">
                                <div class="col">
                                    <mat-form-field appearance="outline">
                                        <mat-label>User ID</mat-label>
                                        <input matInput name="userId" [(ngModel)]="dashboardFilterValues.userId"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>First Name</mat-label>
                                        <input matInput name="firstname" [(ngModel)]="dashboardFilterValues.firstname"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Last Name</mat-label>
                                        <input matInput name="lastName" [(ngModel)]="dashboardFilterValues.lastName"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Student Email</mat-label>
                                        <input matInput name="studentEmail"
                                            [(ngModel)]="dashboardFilterValues.studentEmail"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Supervisor Email</mat-label>
                                        <input matInput name="supervisorEmail"
                                            [(ngModel)]="dashboardFilterValues.supervisorEmail"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Title</mat-label>
                                        <input matInput name="title" [(ngModel)]="dashboardFilterValues.title"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Job Location ID</mat-label>
                                        <input matInput name="jobLocationID"
                                            [(ngModel)]="dashboardFilterValues.jobLocationID"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Job Position ID</mat-label>
                                        <input matInput name="jobPositionID"
                                            [(ngModel)]="dashboardFilterValues.jobPositionID"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>ID Type</mat-label>
                                        <input matInput name="idType" [(ngModel)]="dashboardFilterValues.idType"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Activity Completion Date</mat-label>
                                        <input matInput name="activityCompletionDate"
                                            [(ngModel)]="dashboardFilterValues.activityCompletionDate"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Activity Completion Status</mat-label>
                                        <input matInput name="activityCompletionStatus"
                                            [(ngModel)]="dashboardFilterValues.activityCompletionStatus"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Assignment Date</mat-label>
                                        <input matInput name="assignmentDate"
                                            [(ngModel)]="dashboardFilterValues.assignmentDate"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Assignment Type</mat-label>
                                        <input matInput name="assignmentType"
                                            [(ngModel)]="dashboardFilterValues.assignmentType"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Cluster</mat-label>
                                        <input matInput name="cluster" [(ngModel)]="dashboardFilterValues.cluster"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Percentage Of Completion</mat-label>
                                        <input matInput name="perOfCompletion"
                                            [(ngModel)]="dashboardFilterValues.perOfCompletion"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Program Completion Date</mat-label>
                                        <input matInput name="programCompletionDate"
                                            [(ngModel)]="dashboardFilterValues.programCompletionDate"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Program Completion Status</mat-label>
                                        <input matInput name="programCompletionStatus"
                                            [(ngModel)]="dashboardFilterValues.programCompletionStatus"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Program ID</mat-label>
                                        <input matInput name="programId" [(ngModel)]="dashboardFilterValues.programId"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Program Period</mat-label>
                                        <input matInput name="programPeriod"
                                            [(ngModel)]="dashboardFilterValues.programPeriod"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field appearance="outline" class="fullWidth">
                                        <mat-label>Program Type</mat-label>
                                        <input matInput name="programType"
                                            [(ngModel)]="dashboardFilterValues.programType"
                                            (keyup)="fieldListenerHome()">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                <div class="tableWrap dashboardTable">
                    <table mat-table [dataSource]="dataSource" matSort>
                        <ng-container matColumnDef="userId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> User ID </th>
                            <td mat-cell *matCellDef="let element"> {{element.userId}} </td>
                        </ng-container>
                        <ng-container matColumnDef="lastName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.firstname}} {{element.lastName}} </td>
                        </ng-container>
                        <ng-container matColumnDef="studentEmail">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Student Email </th>
                            <td mat-cell *matCellDef="let element"> {{element.studentEmail}} </td>
                        </ng-container>
                        <ng-container matColumnDef="supervisorEmail">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Supervisor Email </th>
                            <td mat-cell *matCellDef="let element"> {{element.supervisorEmail}} </td>
                        </ng-container>
                        <ng-container matColumnDef="title">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Title </th>
                            <td mat-cell *matCellDef="let element"> {{element.title}} </td>
                        </ng-container>
                        <ng-container matColumnDef="jobLocationID">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Job Location ID </th>
                            <td mat-cell *matCellDef="let element"> {{element.jobLocationID}} </td>
                        </ng-container>
                        <ng-container matColumnDef="jobPositionID">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Job Position ID </th>
                            <td mat-cell *matCellDef="let element"> {{element.jobPositionID}} </td>
                        </ng-container>
                        <ng-container matColumnDef="idType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID Type </th>
                            <td mat-cell *matCellDef="let element"> {{element.idType}} </td>
                        </ng-container>
                        <ng-container matColumnDef="activityCompletionDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Activity Completion Date </th>
                            <td mat-cell *matCellDef="let element"> {{element.activityCompletionDate}} </td>
                        </ng-container>
                        <ng-container matColumnDef="activityCompletionStatus">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Activity Completion Status </th>
                            <td mat-cell *matCellDef="let element"> {{element.activityCompletionStatus}} </td>
                        </ng-container>
                        <ng-container matColumnDef="assignmentDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Assignment Date </th>
                            <td mat-cell *matCellDef="let element"> {{element.assignmentDate}} </td>
                        </ng-container>
                        <ng-container matColumnDef="assignmentType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Assignment Type </th>
                            <td mat-cell *matCellDef="let element"> {{element.assignmentType}} </td>
                        </ng-container>
                        <ng-container matColumnDef="cluster">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Cluster </th>
                            <td mat-cell *matCellDef="let element"> {{element.cluster}} </td>
                        </ng-container>
                        <ng-container matColumnDef="perOfCompletion">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Percentage Of Completion </th>
                            <td mat-cell *matCellDef="let element"> {{element.perOfCompletion}} </td>
                        </ng-container>
                        <ng-container matColumnDef="programCompletionDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Program Completion Date </th>
                            <td mat-cell *matCellDef="let element"> {{element.programCompletionDate}} </td>
                        </ng-container>
                        <ng-container matColumnDef="programCompletionStatus">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Program Completion Status </th>
                            <td mat-cell *matCellDef="let element"> {{element.programCompletionStatus}} </td>
                        </ng-container>
                        <ng-container matColumnDef="programId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Program ID </th>
                            <td mat-cell *matCellDef="let element"> {{element.programId}} </td>
                        </ng-container>
                        <ng-container matColumnDef="programPeriod">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Program Period </th>
                            <td mat-cell *matCellDef="let element"> {{element.programPeriod}} </td>
                        </ng-container>
                        <ng-container matColumnDef="programType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Program Type </th>
                            <td mat-cell *matCellDef="let element"> {{element.programType}} </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <mat-paginator [length]="totalData" [pageSizeOptions]="[100]" showFirstLastButtons
                    (page)="pageChanged($event)">
                </mat-paginator>
            </div>
        </div>
    </mat-card-content>
</mat-card>